<template>
  <section class="ewptx-presale__section">
    <div class="ewptx-presale__content">
      <div class="ewptx-presale__text">
        <div class="ewptx-presale__text-title-enquiry">PRE-SALE SAVINGS FOR NEW SUBSCRIBERS</div>
        <div class="ewptx-presale__text-title">Buy now and save $200!</div>
        <div class="ewptx-presale__details">
          Pre-Sale available now for <strong>NEW SUBSCRIBERS!</strong> Purchase the eWPTX exam
          voucher during pre-sale and receive three months of INE’s Premium subscription to help you
          prepare! Don’t wait – purchase during pre-sale and <strong>SAVE $200</strong> off regular
          pricing. You’ll be one of the first eligible to take the eWPTX exam when it becomes
          available on December 19th, 2024.
        </div>
        <div class="ewptx-presale__cta">
          <button class="btn btn--primary btn--responsive btn--full-mobile" @click="claimDealCTA">
            Claim this deal
          </button>
        </div>
      </div>
      <img
        :src="require(`@/assets/icons/certs/ewptx_badge.png`)"
        alt="eWPTX Premium Dynamic Exam"
        class="ewptx-presale__badge"
      />
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { updateCart } from '@/helpers/mixins'
import CONSTANTS from '@/constants'

export default {
  name: 'EwptxPreSaleSection',
  mixins: [updateCart],
  methods: {
    getPlan(merchantId) {
      return this.availablePlans.find(plan => plan.merchant_id === merchantId)
    },
    claimDealCTA() {
      const currentPlan = this.getPlan(CONSTANTS.PLANS.EWPTX_PREMIUM)
      this.updateSelectedPlan(currentPlan)
      this.$router.push({
        name: this.userProfile.email ? 'payment' : 'account',
      })
    },
  },
  computed: {
    ...mapState({
      availablePlans: state => state.products.availablePlans,
      userProfile: state => state.auth.userProfile,
    }),
  },
}
</script>

<style lang="scss">
.ewptx-presale {
  &__section {
    padding: 30px 20px;
    @include mobile {
      padding: 20px;
    }
    @include desktop {
      padding: 90px 20px;
    }
  }
  &__content {
    display: flex;
    flex-flow: column-reverse;
    align-items: center;
    gap: 40px;
    @include mobile {
      flex-flow: row;
      gap: 40px;
    }
    @include desktop {
      gap: 60px;
      max-width: 1120px;
      margin: auto;
      align-items: center;
    }
  }
  &__badge {
    width: 50%;
    @include mobile {
      width: 363px;
    }
    @include desktop {
      width: 392px;
    }
  }
  &__text {
    font-family: var(--font-medium);
    color: var(--white);
    &-title {
      margin-top: 10px;

      color: var(--white);
      font-feature-settings: 'clig' off, 'liga' off;

      font-family: var(--font-regular);
      font-size: 2rem;
      font-style: normal;
      font-weight: 700;
      line-height: 2.375rem; /* 118.75% */

      @include mobile {
        font-size: 2.5rem;
        line-height: 3.25rem;
      }
      @include desktop {
        font-size: 3.375rem;
        line-height: 3.75rem;
      }
      &-enquiry {
        color: var(--light-purple);
        font-feature-settings: 'clig' off, 'liga' off;
        text-shadow: 0px 0px 24px #000;

        font-family: var(--font-regular);
        font-size: 0.875rem;
        font-style: normal;
        font-weight: 500;
        line-height: 1.25rem; /* 142.857% */

        @include mobile {
          font-size: 1rem;
          line-height: 1.4375rem;
        }
        @include desktop {
          font-size: 0.9375rem;
          font-weight: 700;
          line-height: 0.875rem;
        }
      }
    }
  }
  &__details {
    margin-top: 10px;

    color: var(--white);
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: var(--font-regular);
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 450;
    line-height: 1.25rem; /* 142.857% */

    @include desktop {
      font-size: 1.125rem;
      line-height: 1.5rem;
    }
    &--link {
      color: var(--purple-pale);
      font-size: rem(18px);
      font-style: normal;
      font-weight: 450;
      line-height: rem(24px);
      cursor: pointer;
    }
  }
  &__cta {
    margin-top: 10px;
    @include mobile {
      margin-top: 20px;
    }
    @include desktop {
      margin-top: 40px;
    }
    &--hide {
      display: none !important;
    }
  }
}
</style>
